import template from './vessel-access-group-name.html';

function ViewModel(params) {
    var self = this;
    self.accessGroup = params.accessGroup;
}

export default { viewModel: ViewModel, template: template }